module.exports = __webpack_public_path__ + "media/images/emblems/Wittenba-a6108fa4f9a6f16c7b6ea8ba3b91d69c.png";